module.exports = __webpack_public_path__ + "img/transpress-3PL-services.d7244a7a.jpg";